import ApiService from "../../common/api.service";
import Vue from "vue";

const state = {
  all: [],
  cache: {}
};

// getters
const getters = {
  getById: state => id => {
    return state.all[state.cache[id]];
  },
  getAll: state => {
    return state.all;
  }
};

// actions
const actions = {
  add(context, item) {
    return new Promise((resolve, reject) => {
      ApiService.post("/courses", item)
        .then(response => {
          context.commit("ADD", response.data);
          context.dispatch("getAll");
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  update(context, item) {
    return new Promise((resolve, reject) => {
      ApiService.put("/courses/" + item.id, item)
        .then(response => {
          context.commit("UPDATE", response.data);
          context.dispatch("getAll");
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  delete(context, item) {
    return new Promise((resolve, reject) => {
      ApiService.delete("/courses/" + item.id, item)
        .then(() => {
          context.commit("DEL", item);
          context.dispatch("getAll");
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAll(context) {
    ApiService.get("/courses").then(response => {
      context.commit("SET", response.data);
    });
  },
  prepareEvents(context, item) {
    return new Promise((resolve, reject) => {
      ApiService.post("/courses/events", item)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  export(context, filter) {
    return new Promise(resolve => {
      filter.type = "course";
      ApiService.query("/export", { params: filter }).then(response => {
        resolve(response);
      });
    });
  }
};

// mutations
const mutations = {
  ADD(state, item) {
    state.all.push(item);
    state.cache[item.id] = state.all.length - 1;
  },
  SET(state, items) {
    state.all = items;
    createCache(items);
  },
  UPDATE(state, item) {
    const index = state.cache[item.id];
    Vue.set(state.all, index, item);
  },
  DEL(state, item) {
    state.all.splice(state.cache[item.id], 1);
  }
};

function createCache(items) {
  for (let i = 0; i < items.length; i++) {
    state.cache[items[i].id] = i;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
